import Vue from 'vue'
import router from './router'
import iView from 'iview'
// import 'amfe-flexible'
import 'iview/dist/styles/iview.css'    // 使用 CSS
import store from './store/index';
window.Promise = Promise;
import App from './App'
// import './common/css/reset.css'
// import './common/css/common.css'
// import './common/font/style.css'
import {Message} from 'iview'
import "mtils"

Vue.prototype.$Message = Message;
Vue.use(iView);

router.beforeEach((to, from, next) => {
    store.dispatch('setRouterName', to.name);
    next();
});

iView.Message.config({
    top: 150,
    duration: 3
});

// 跳转后返回顶部
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

Vue.config.productionTip = false;
new Vue({
    el: '#app',
    router,
    store: store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js